import { render, staticRenderFns } from "./BaseListActions.vue?vue&type=template&id=2c9e2024"
import script from "./BaseListActions.vue?vue&type=script&lang=js"
export * from "./BaseListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports